import stringHash from "string-hash";

/**
 * Helper to generate user-specific dismiss keys.
 *
 * By making dismiss keys user specific this avoids a situation where one user
 * could dismiss a site banner would prevent another user using the same machine
 * from seeing that banner.
 *
 * NOTE: This doesn't do anything to address the issue of logged-out users
 * dismissing banners from affect what banners other logged out users see.
 */
export const getBaseKey = (
    bannerName: string,
    kaid?: string | null,
): string => {
    return kaid ? `${bannerName}_${stringHash(kaid)}` : bannerName;
};

export const getDismissKey = (
    bannerName: string,
    kaid?: string | null,
): string => {
    return getBaseKey(bannerName, kaid);
};

/**
 * Generate key for storing the timestamp when a banner is shown.
 */
export const getBannerShownKey = (bannerName: string, kaid?: string | null) => {
    const baseKey = getBaseKey(bannerName, kaid);
    return `${baseKey}_shown`;
};
